import { useMutation, useQueryClient } from 'react-query';
import { useSnackbar } from 'notistack';
import CustomerService from '../../services/customer.service';
import { COMPANY_MEMBERS_QUERY_KEY } from '../../constants/query';
import { pagesText } from '../../constants/pagesText';

const useResendInvites = () => {
  const queryClient = useQueryClient();
  const { enqueueSnackbar } = useSnackbar();

  return useMutation(CustomerService.resendInvitation, {
    onError: error => {
      enqueueSnackbar(error, {
        variant: 'error',
        autoHideDuration: 3000,
        preventDuplicate: true,
      });
    },

    onSuccess: async () => {
      await queryClient.invalidateQueries([COMPANY_MEMBERS_QUERY_KEY]);

      enqueueSnackbar(pagesText.inviteUsers.addCustomerSnackbar, {
        variant: 'success',
        autoHideDuration: 3000,
      });
    },
  });
};

export default useResendInvites;
